import { useNavigate, useParams } from "react-router-dom";
import styles from "./PageTour.module.css"
import stylesInfo from "../InfoTour/InfoTour.module.css"
import { useContext, useEffect, useState } from "react";
import SpinPage from "../../../../components/UI/Spin/Spin";
import formatCurrency from "../../../../Utils/formatCurrency";
import Footer from "../../../../components/Footer/Footer";
import ServerService from "../../../../service/ServerService";
import { Context } from "../../../..";
import ErrorComponent from "../../../../components/UI/Error/ErrorComponent";
import { NAME_SERVER } from "../../../../Utils/NAME_HOST";


function PageTour() {
    const { id } = useParams()
    const { store } = useContext(Context)
    const navigate = useNavigate();
    const [data, setData] = useState({})
    const [timeFacts, setTimeFacts] = useState(null);
    const [statusLoadingPage, setStatusLoadingPage] = useState(true);
    const [statusDopDesc, setStatusDopDesc] = useState(false);
    const places_dop = [[1, "100 000 000"], [2, "55 000 000"], [3, "40 000 000"], ["4-23", "2 000 000"]]
    async function main() {
        try {
            const response = await ServerService.get_tournaments(id);
            const data = response.data
            if (data.status === 0) {
                navigate("/tournaments")
                store.add_message(data.err, ErrorComponent)

            }
            if (data.status === 1) {
                setData(data.data)
                console.log(data.info_placement)


                setTimeFacts(data.data.date_end)



                setStatusLoadingPage(false);
            }

        }
        catch (e) {
            console.log("error")
            console.error(e, "Error");
        }
    }
    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    useEffect(() => {
        main();
        store.set_visible_right_panel(false);
        const interval = setInterval(() => {

            setTimeFacts(prev => prev - 1);


        }, 1000)
        return () => clearInterval(interval);


    }, [])
    if (statusLoadingPage) {
        return <SpinPage />
    }
    return (
        <>

            <div className={styles.main}>
                <div className={styles.containerHeader}>
                    <div className={stylesInfo.header} dangerouslySetInnerHTML={{ __html: data.name }}>

                    </div>
                    <div className={styles.containerTime}>
                        <div className={stylesInfo.headerSmall}>{timeFacts < 0 ? "Турнир завершен" : "До окончания турнира"}</div>
                        {timeFacts > 0 && <p className={stylesInfo.timeReg}>{formatTime(timeFacts)}</p>}
                    </div>
                </div>
                <div className={`${stylesInfo.blockTour}`} style={{ cursor: "default" }}>


                    <div className={stylesInfo.gamecard_window}>
                        {/* <div className={styles.top}>
                    <div>



                        <div className={`${styles.amount} skeleton-button`}>
                            <div className={styles.info_prize}>Призовой фонд</div>

                            {formatCurrency(amount, "cost")}
                        </div>


                    </div>

                </div> */}
                        {/* {!isPhone && <div className={`${styles.buttonPlay} wallet_nav_bar`} style={{ opacity: statusEnter ? 1 : 0.9 }}>Участвовать</div>} */}

                        <img src={data.image} />

                    </div>
                    <div className={stylesInfo.containerInformation}>

                        <div className={`${stylesInfo.amount} skeleton-button`}>
                            <div className={stylesInfo.info_prize}>Призовой фонд</div>
                            {formatCurrency(data.amount, "cost")}
                        </div>
                        <div className={styles.description} dangerouslySetInnerHTML={{ __html: data.description }}>

                        </div>
                        <div className={styles.InfWin}>


                            {data.places.map((value, index) =>
                                <div className={styles.containerPlace}>
                                    <div className={styles.place}>{value[0]} {typeof value[0] === "number" ? "Место" : "Места"}</div>
                                    <div className={styles.win}>{formatCurrency(value[1], "cost")}</div>
                                </div>
                            )}



                        </div>

                    </div>
                </div>
                {data.dop_description && <div className={styles.wrapperDopDesc}>


                    <div className={styles.dop_desc}>
                        {data.dop_description.name} <div className={styles.wrapperCoins}><img src={NAME_SERVER + "/assets/" + data.dop_description.icon} width={20} /> <span style={{ color: "gold" }}>{data.dop_description.prize}</span></div>
                    </div>
                    {statusDopDesc && <div className={styles.InfWin} style={{ justifyContent: "flex-start" }}>


                        {(data.dop_description.places_dop).map((value, index) =>
                            <div className={styles.containerPlace}>
                                <div className={styles.place}>{value[0]} {typeof value[0] === "number" ? "Место" : "Места"}</div>
                                <div className={`${styles.win} ${styles.dop}`}><img src={NAME_SERVER + "/assets/" + data.dop_description.icon} width={20} />{value[1]}</div>
                            </div>
                        )}



                    </div>}
                    <p className={styles.dop_button} onClick={() => setStatusDopDesc(prev => !prev)}>{statusDopDesc ? "Скрыть" : "Подробнее"}</p>
                </div>}

                <div className={styles.wrapperTable}>
                    <div className={styles.headerTable}>
                        {data.user_position === null ? "У вас еще нет выигрыша" : <div>Ваша позиция <span style={{ color: "rgba(255, 255, 255, 0.522)", marginLeft: "5px", fontSize: "25px" }}>{data.user_position}</span></div>}
                        <span style={{ color: "rgba(255, 255, 255, 0.522)", fontSize: "25px" }}>X{data.user_x}</span>


                    </div>

                    <div className={styles.wrapperUsers} style={{ borderEndEndRadius: 0, borderEndStartRadius: 0 }}>
                        <div className={styles.containerUsers}>
                            {data.users.slice(0, 3).map((value, place) =>
                                <div className={styles.containerUser} style={{ background: data.user_position === (place + 1) && "#06d91340", borderRadius: data.user_position === (place + 1) && "10px" }}>
                                    <div className={styles.infoPlace}>{place + 1}</div>
                                    <div className={styles.infoUser}>
                                        <div>{value.login}</div>
                                        <div>X{value.koef}</div>
                                    </div>

                                </div>
                            )}


                        </div>
                    </div>

                    <div className={styles.wrapperUsers}>

                        <div className={styles.containerUsers}>
                            {data.users.slice(3, Math.ceil((data.placement_display - 3) / 2) + 3).map((value, place) =>
                                <div className={styles.containerUser} style={{ background: data.user_position === (place + 4) && "#06d91340", borderRadius: data.user_position === (place + 4) && "10px" }}>
                                    <div className={styles.infoPlace}>{place + 4}</div>
                                    <div className={styles.infoUser}>
                                        <div>{value.login}</div>
                                        <div>X{value.koef}</div>
                                    </div>

                                </div>
                            )}


                        </div>
                        <div className={styles.containerUsers}>
                            {data.users.slice(Math.ceil((data.placement_display - 3) / 2) + 3, data.placement_display).map((value, place) =>
                                <div className={styles.containerUser} style={{ background: data.user_position === (place + 1 + Math.ceil((data.placement_display - 3) / 2) + 3) && "#06d91340", borderRadius: data.user_position === (place + 1 + Math.ceil((data.placement_display - 3) / 2) + 3) && "10px" }}>
                                    <div className={styles.infoPlace}>{place + 1 + Math.ceil((data.placement_display - 3) / 2) + 3}</div>
                                    <div className={styles.infoUser}>
                                        <div>{value.login}</div>
                                        <div>X{value.koef}</div>
                                    </div>

                                </div>
                            )}


                        </div>

                    </div>

                </div>


            </div >
            <Footer />
        </>
    )
}
export default PageTour;